import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className, invalid, ...rest }, ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'w-full h-10 px-3 rounded-lg border bg-white text-ink',
        'placeholder:text-slate-400 transition-colors',
        invalid ? 'border-bad focus:border-bad' : 'border-slate-300 focus:border-ink',
        'disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  );
});
